import React from "react";
import usePostApprovalPlaidSkip from "../../../hooks/usePostApprovalPlaidSkip";
import Alert from "../../shared/Alert";
import PostApprovalPlaidSkipped from "./PostApprovalPlaidSkipped";

const defaultLabel = "Skip for now";

export default function PostApprovalPlaidSkip({
  onSkipped,
  onContinue,
  autoContinue = false,
  label = defaultLabel,
}) {
  const plaidSkip = usePostApprovalPlaidSkip();
  const isBusy =
    plaidSkip.loading ||
    ["skipping", "confirming"].includes(plaidSkip.skipState);
  const skip = () => {
    Promise.resolve(plaidSkip.skipOnce()).catch(() => undefined);
  };
  const retry = () => {
    Promise.resolve(plaidSkip.retrySkip()).catch(() => undefined);
  };

  if (plaidSkip.skipState === "skipped") {
    return (
      <PostApprovalPlaidSkipped
        {...plaidSkip}
        autoContinue={autoContinue}
        onContinue={onContinue}
        onSkipped={onSkipped}
      />
    );
  }

  return (
    <div>
      {plaidSkip.skipState === "error" && (
        <div className="mb-3">
          <Alert
            containerClass="bg-red-50 p-4"
            icon={["far", "circle-xmark"]}
            alertText="We couldn't update your application. Your current approval is unchanged."
          />
          <button
            className="mt-2 text-sm text-primary-blue underline"
            onClick={retry}
            type="button"
          >
            Try again
          </button>
        </div>
      )}
      <button
        aria-busy={isBusy}
        className="post-approval-skip"
        data-testid="outline-submit-button"
        disabled={isBusy || !plaidSkip.canSkip}
        onClick={skip}
        type="button"
      >
        {label}
      </button>
    </div>
  );
}
